<template>
  <section class="redeem">
    <div class="myProfitz">
      <p>SALDO PARA RESGATE:</p>
      <h2>
        <span>{{ Math.round(card_balance) }}</span> profitz
      </h2>
    </div>

    <!-- <div class="bag">
      <div class="bag__title" @click="openBag = !openBag">
        <i class="fas fa-shopping-bag"></i>
        <p>MINHA SACOLA</p>
      </div>

      <div class="myBag" v-if="openBag">
        <h2>ITENS NA SACOLA</h2>
        <div class="bag__items" v-if="openBag">
          <div class="item__image">
            <img
              src="../../../assets/bone_claro_frente.jpg"
              alt=" "
              width="70px"
            />
          </div>

          <div class="item__details">
            <p>Boné Claro Profiz</p>
            <p>220 Profitz</p>
            <button><i class="fas fa-window-minimize"></i></button>
            <span>0</span>
            <button><i class="fas fa-plus"></i></button>
          </div>

          <div class="item__iconTrash">
            <a href="javascript:void(0)"><i class="far fa-trash-alt"></i></a>
          </div>
        </div>
        <div class="bag__items">
          <div class="item__image">
            <img
              src="../../../assets/bone_claro_frente.jpg"
              alt=" "
              width="70px"
            />
          </div>

          <div class="item__details">
            <p>Boné Claro Profiz</p>
            <p>220 Profitz</p>
            <button><i class="fas fa-window-minimize"></i></button>
            <span>0</span>
            <button><i class="fas fa-plus"></i></button>
          </div>

          <div class="item__iconTrash">
            <a href="javascript:void(0)"><i class="far fa-trash-alt"></i></a>
          </div>
        </div>
        <div class="bag__items" v-if="openBag">
          <div class="item__image">
            <img
              src="../../../assets/bone_claro_frente.jpg"
              alt=" "
              width="70px"
            />
          </div>

          <div class="item__details">
            <p>Boné Claro Profiz</p>
            <p>220 Profitz</p>
            <button><i class="fas fa-window-minimize"></i></button>
            <span>0</span>
            <button><i class="fas fa-plus"></i></button>
          </div>

          <div class="item__iconTrash">
            <a href="javascript:void(0)"><i class="far fa-trash-alt"></i></a>
          </div>
        </div>

        <div class="bag__address">
          <h2>ENDEREÇO DE ENVIO</h2>
          <div class="rows">
            <div class="form-groups">
              <label for="">CEP</label>
              <input type="text" />
            </div>
            <div class="form-groups">
              <label for="">Rua / Avenida</label>
              <input type="text" />
            </div>
            <div class="form-groups">
              <label for="">Número</label>
              <input type="number" />
            </div>
          </div>

          <div class="rows">
            <div class="form-groups">
              <label for="">Bairro</label>
              <input type="text" />
            </div>
            <div class="form-groups">
              <label for="">Complemento</label>
              <input type="text" />
            </div>
          </div>

          <div class="rows">
            <div class="form-groups">
              <label for="">Cidade</label>
              <input type="text" />
            </div>
            <div class="form-groups">
              <label for="">Estado</label>
              <input type="text" />
            </div>
          </div>

          <button>FINALIZAR RESGATE</button>
        </div>
      </div>
    </div> -->

    <div class="products">
      <div class="item" v-for="item in brindes" :key="item.id">
        <img :src="item.imagem" :alt="item.nome" />
        <p class="item__name">{{ item.nome }}</p>
        <p class="item__available">
          Disponível: <span>{{ item.quantidade }} un</span>
        </p>
        <h2 class="item__value">{{ item.valor }} Profitz</h2>
        <p
          class="item__insufficient"
          v-if="Math.round(card_balance) < item.valor * quantidadeTotal"
        >
          Você não possui Profitz suficiente
        </p>
        <div class="item__group" v-if="Math.round(card_balance) > item.valor">
          <div class="quantityRedeem__quantity">
            <button @click="diminuirQuantidade">
              <i class="fas fa-window-minimize"></i>
            </button>
            <span>{{ quantidadeTotal }}</span>
            <button @click="aumentarQuantidade">
              <i class="fas fa-plus"></i>
            </button>
          </div>

          <div
            class="quantityRedeem__redeem"
            v-if="Math.round(card_balance) > item.valor * quantidadeTotal"
          >
            <button>RESGATAR</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      openBag: false,
      card_balance: 0,
      quantidade: 1,
      brindes: [
        {
          id: 1,
          nome: "Boné Profiz Claro",
          quantidade: 1,
          valor: 10,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/bone_claro_frente.jpg",
        },
        {
          id: 2,
          nome: "Boné Profiz Preto",
          quantidade: 2,
          valor: 90,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/bone_preto_frente_profiz.jpg",
        },
        {
          id: 3,
          nome: "Capacete Profiz Amarelo",
          quantidade: 5,
          valor: 50,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/capacete_amarelo_frente.jpg",
        },
        {
          id: 4,
          nome: "Capacete Profiz Preto",
          quantidade: 10,
          valor: 50,
          imagem: "https://multiar.vteximg.com.br/arquivos/capacete_frente.jpg",
        },
        {
          id: 5,
          nome: "Capacete Profiz Verde",
          quantidade: 8,
          valor: 50,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/capacete_verde_frente.jpg",
        },
        {
          id: 6,
          nome: "Cooler Profiz",
          quantidade: 2,
          valor: 250,
          imagem: "https://multiar.vteximg.com.br/arquivos/cooler.jpg",
        },
        {
          id: 7,
          nome: "Kit 1 Camiseta Cinza",
          quantidade: 30,
          valor: 750,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/kit1_camiseta_cinza.jpg",
        },
        {
          id: 8,
          nome: "Kit 2 Camiseta Verde",
          quantidade: 30,
          valor: 750,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/kit1_camiseta_verde.jpg",
        },
        {
          id: 9,
          nome: "Kit 3 Camiseta Verde",
          quantidade: 30,
          valor: 750,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/kit2_camiseta_verde.jpg",
        },
        {
          id: 10,
          nome: "Polo Profiz Cinza",
          quantidade: 10,
          valor: 250,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/polo_profiz_cinza_frente.jpg",
        },
        {
          id: 11,
          nome: "Polo Profiz Preta",
          quantidade: 30,
          valor: 250,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/polo_profiz_preta_frente.jpg",
        },
        {
          id: 12,
          nome: "Polo Profiz Verde",
          quantidade: 3,
          valor: 250,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/polo_profiz_verde_frente.jpg",
        },
        {
          id: 13,
          nome: "Camiseta Profiz Cinza",
          quantidade: 2,
          valor: 300,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/camiseta_profiz_cinza_frente.jpg",
        },
        {
          id: 14,
          nome: "Camiseta Profiz Original",
          quantidade: 2,
          valor: 400,
          imagem:
            "https://multiar.vteximg.com.br/arquivos/camisetaTshirt_frente.jpg",
        },
      ],
    };
  },

  computed: {
    quantidadeTotal() {
      return this.quantidade;
    },
  },

  methods: {
    aumentarQuantidade() {
      this.quantidade++;
    },

    diminuirQuantidade() {
      if (this.quantidade > 1) {
        this.quantidade--;
      }
    },
  },

  beforeMount() {
    let dados = JSON.parse(localStorage.getItem("login"));
    //Consulta Profitz
    axios
      .get(`https://leverosintegra.dev.br/api/bcdigital/registerOld/${dados.cpfCnj}`)
      .then((res) => {
        if (res.data == "") {
          this.card_balance = 0;
        } else {
          this.card_balance = res.data.card_balance / 100;
        }
      });
  },
};
</script>

<style lang="scss" scoped>
.redeem {
  max-width: 95%;
  margin: 0 auto;
  padding: 50px 0;

  @media (min-width: 441px) {
    max-width: 87%;
  }

  .myProfitz {
    text-align: center;
    padding-bottom: 40px;

    p {
      padding-bottom: 15px;
    }

    h2 {
      font-weight: 500;

      span {
        font-weight: 700;
      }
    }
  }

  .bag {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    padding: 10px;
    max-width: 95%;
    margin: 0 auto;

    .myBag {
      padding-top: 30px;
      h2 {
        font-size: 0.875rem;
        margin-left: 20px;
      }
    }

    &__title {
      display: flex;
      align-items: center;

      i {
        color: #005a64;
        font-size: 1.5rem;
        vertical-align: super;
      }

      p {
        margin-left: 10px;
        cursor: pointer;
        font-size: 0.875rem;
      }
    }

    &__items {
      display: flex;
      align-items: center;
      padding-top: 30px;

      .item {
        &__details {
          margin: 0 50px 0 15px;
          line-height: 1.5;
          font-size: 0.875rem;

          p {
            &:nth-child(2) {
              font-weight: 700;
              color: #005a64;
            }
          }

          button {
            padding-top: 10px;
            i {
              color: #005a64;
            }
          }

          span {
            background: #ececec;
            border-radius: 5px;
            padding: 5px 10px;
            margin: 0 10px;
          }
        }

        &__iconTrash {
          i {
            color: #002d32;
          }
        }
      }
    }

    &__address {
      padding-top: 70px;

      h2 {
        font-size: 0.875rem;
        margin-left: 20px;
        padding-bottom: 10px;
      }
      .rows {
        display: flex;
        margin: 20px 0;

        label {
          font-size: 0.875rem;
        }

        input {
          border-bottom: 1px solid #949494;
          outline: none;
          font-size: 0.875rem;
          margin: 10px 0;

          &:focus {
            border-bottom: 2px solid #0e0e0e;
          }
        }
      }

      .form-groups {
        display: flex;
        flex-direction: column;
        margin: 0 20px;
      }

      button {
        background: #005a64;
        color: #fff;
        border-radius: 5px;
        padding: 8px;
        margin: 20px;
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
          0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
        letter-spacing: 0.0892857143rem;
        font-size: 0.875rem;
      }
    }
  }

  .products {
    display: flex;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
    padding-top: 40px;

    .item {
      width: 45%;
      margin: 7px;
      padding: 10px 10px 20px 10px;
      border: 1px solid #e7e7e7;
      border-radius: 5px;
      text-align: center;

      &:hover {
        position: relative;
        top: -10px;
      }

      @media (min-width: 441px) and (max-width: 768px) {
        width: 47%;
      }

      @media (min-width: 769px) {
        width: 23%;
      }

      img {
        max-width: 100%;
        height: auto;
      }

      &__name {
        font-size: 1rem;
        padding-bottom: 10px;
      }

      &__available {
        font-size: 0.75rem;
        padding-top: 5px;

        span {
          font-weight: 700;
        }
      }

      &__value {
        font-size: 1.2rem;
        font-weight: 700;
        padding: 15px 0 25px 0;
        color: #005a64;
      }

      &__group {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        flex-direction: column;

        @media (min-width: 441px) {
          flex-direction: row;
        }

        .quantityRedeem {
          &__quantity {
            @media (max-width: 441px) {
              margin-bottom: 20px;
            }
            button {
              color: #005a64;
              font-weight: 700;
              margin: 0 10px;

              &:nth-child(1) {
                position: relative;
                top: -5px;
              }
            }

            span {
              background: #ececec;
              padding: 10px 15px;
              border-radius: 5px;
            }
          }

          &__redeem {
            background: #002d32;
            border-radius: 5px;
            color: #fff;
            padding: 8px;
            font-size: 0.875rem;
            box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
              0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
            letter-spacing: 0.0892857143rem;

            &:hover {
              opacity: 0.9;
            }
          }
        }
      }

      &__insufficient {
        font-size: 0.75rem;
        padding: 0 0 15px 0;
        color: red;
      }
    }
  }
}
</style>